export default __webpack_public_path__ + "images/a71ec7c2f4c4919b82dca6aae30022bf.svg";